/**
 * Shared cable variant lookup for Cable PDP popup (make / model / year → variant IDs).
 * Coalesces concurrent requests with the same vehicle key to avoid duplicate API calls.
 */
(function (global) {
  var inflightByKey = Object.create(null);

  function vehicleKey(make, model, year) {
    return String(make) + "\u0000" + String(model) + "\u0000" + String(year);
  }

  function getApiUrl() {
    return global.api_URL_cables_list || "";
  }

  /**
   * @returns {Promise<object>} Parsed JSON body from get_cables API
   */
  function fetchCableLookup(make, model, year, sfId, authToken) {
    var key = vehicleKey(make, model, year);
    if (inflightByKey[key]) {
      return inflightByKey[key];
    }
    var p = fetch(getApiUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authToken,
      },
      body: JSON.stringify({
        make: make,
        model: model,
        year: year,
        SFID: sfId,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(res.statusText);
        }
        return res.json();
      })
      .finally(function () {
        delete inflightByKey[key];
      });
    inflightByKey[key] = p;
    return p;
  }

  /** Normalize API payload to a list of variant id strings (handles records vs body.records). */
  function getRecordsList(data) {
    if (!data) return [];
    if (Array.isArray(data.records)) return data.records;
    if (data.body && Array.isArray(data.body.records)) return data.body.records;
    return [];
  }

  /**
   * Append mapped cable rows only; skip variant IDs missing from Shopify maps.
   * @returns {number} count of rows rendered
   */
  function appendCableRows(optionalBox, productIds, createProductElement) {
    var rendered = 0;
    if (!optionalBox || !productIds || !createProductElement) return rendered;
    for (var i = 0; i < productIds.length; i++) {
      var el = createProductElement(productIds[i]);
      if (!el) continue;
      optionalBox.appendChild(el);
      rendered++;
    }
    return rendered;
  }

  global.NDCablePdpLookup = {
    fetchCableLookup: fetchCableLookup,
    getRecordsList: getRecordsList,
    appendCableRows: appendCableRows,
  };
})(typeof window !== "undefined" ? window : this);
